import { ref, } from "vue";

export function useToggle() {
    let isOpen = ref(false);
    let toggle = () => {
        isOpen.value = !isOpen.value
    }
    const open = () => {
        isOpen.value = true;
    }
    const close = () => {
        isOpen.value = false;
    }

    return {
        isOpen,
        toggle,
        open,
        close
    }
}